import { render, staticRenderFns } from "./historyForm.vue?vue&type=template&id=9f1ac684&scoped=true"
import script from "./historyForm.vue?vue&type=script&lang=js"
export * from "./historyForm.vue?vue&type=script&lang=js"
import style0 from "./historyForm.vue?vue&type=style&index=0&id=9f1ac684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1ac684",
  null
  
)

export default component.exports